// import Store from '@/store'
import i18n from '@/i18n'

const headerData = (vm, title) => {
    const headerVal = []
    headerVal[0] = vm.reportHeadData.orgName
    headerVal[1] = vm.reportHeadData.address
    headerVal[2] = vm.reportHeadData.heading
    headerVal[3] = title
    headerVal[4] = ''
    headerVal[5] = getHeadParam(vm)
    headerVal[6] = ''
    return headerVal
}

const excelBody = (vm) => {
    const listData = vm.traineeList.length > 0 ? vm.traineeList : []
    const listContractor = []
    if (listData.length > 0) {
      listData.map((item, index) => {
        const myObj = {}
        myObj[vm.$t('globalTrans.sl_no')] = vm.$n(index + 1)
        myObj[vm.$t('trainer_trainee.training_title')] = vm.getTraining(item.training_name_id)
        myObj[vm.$t('trainer_trainee.batch')] = vm.getBatch(item.batch_id)

        let material = ''
         let qty = ''
        item.details.map((itm, indx) => {
            material = material + (indx !== 0 ? ', ' : '')
            material = material + (i18n.locale === 'bn' ? itm.material_name_bn : itm.material_name) + ' - ' + vm.$n(itm.quantity)
             qty = qty + (indx !== 0 ? ', ' : '')
             qty = qty + vm.$n(itm.quantity)
        })
        myObj[vm.$t('tp_management.material_name') + ' ' + vm.$t('globalTrans.and') + ' ' + vm.$t('globalTrans.quantity')] = material
        /* myObj[vm.$t('globalTrans.quantity')] = qty */
        myObj[vm.$t('tp_management.total_cost')] = vm.$n(item.total_cost)
        myObj[vm.$t('application_management.remarks')] = item.remarks
        listContractor.push(myObj)
      })
    }
    return listContractor
}

const getHeadParam = (vm) => {
    let head = ''
    if (vm.search.fiscal_year_id) {
      head = vm.$t('grant_budget_management.fiscal_year') + ' : ' + vm.getFiscalYear(vm.search.fiscal_year_id)
    } else {
      head = vm.$t('grant_budget_management.fiscal_year') + ' : ' + vm.$t('globalTrans.all')
    }
    if (vm.search.circular_id) {
      head = head + ', ' + vm.$t('trainer_trainee.circular_memo_no') + ' : ' + vm.getCircularMemo(vm.search.circular_id)
    } else {
      head = head + ', ' + vm.$t('trainer_trainee.circular_memo_no') + ' : ' + vm.$t('globalTrans.all')
    }
    if (vm.search.training_name_id) {
      head = head + ', ' + vm.$t('trainer_trainee.training_title') + ' : ' + vm.getTraining(vm.search.training_name_id)
    } else {
      head = head + ', ' + vm.$t('trainer_trainee.training_title') + ' : ' + vm.$t('globalTrans.all')
    }
    if (vm.search.batch_id) {
      head = head + ', ' + vm.$t('elearning_config.batch') + ' ' + vm.$t('globalTrans.name') + ' : ' + vm.getBatch(vm.search.batch_id)
    } else {
      head = head + ', ' + vm.$t('elearning_config.batch') + ' ' + vm.$t('globalTrans.name') + ' : ' + vm.$t('globalTrans.all')
    }
    return head
}

export default {
    headerData,
    excelBody
}
